import { useLiveData, useService } from '@toeverything/infra';
import { useCallback } from 'react';

import { AppSidebarService } from '../../services/app-sidebar';
import { navHeaderLogoStyle, navHeaderStyle } from '../index.css';
import { SidebarSwitch } from './sidebar-switch';
import { WorkbenchService } from '@affine/core/modules/workbench';
import { WorkspaceService } from '@affine/core/modules/workspace';

export const SidebarHeader = () => {
  const appSidebarService = useService(AppSidebarService).sidebar;
  const open = useLiveData(appSidebarService.open$);
  const workbenchService = useService(WorkbenchService);
  const workbench = workbenchService.workbench;
  const workspaceService = useService(WorkspaceService);

  const handleOpenHome = useCallback(() => {
    workbench.openDoc('home');
    // ✅ chat.created 事件已移至 HomePage 组件中处理，避免在这里持有 workspace 引用
    workspaceService.workspace.eventBus.emit(
      { id: 'chat.created', _type: 'chat.created' },
      {}
    );
  }, [workbench, workspaceService]);

  return (
    <div className={navHeaderStyle} data-open={open}>
      <img
        onClick={handleOpenHome}
        className={navHeaderLogoStyle}
        src="https://wy-static.wenxiaobai.com/wenxiaobai-web/web-image/muset/sidebar-logo.png"
      />
      <SidebarSwitch show={open} />
    </div>
  );
};

export * from './sidebar-switch';
